<script>

import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import medicionAusentismoAPI from "@/services/standards/medicionAusentismo/medicionAusentismoAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Autocomplete from "@/components/standard/medicionAusentismo/Autocomplete";
import { required, minLength } from 'vuelidate/lib/validators'
/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.6 Medición del ausentismo por causa médica",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Autocomplete,
  },
  data() {

    return {
      submi: false,
      title: "3.3.6 Medición del ausentismo por causa médica",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "3.3.6 Medición del ausentismo por causa médica",
        },
        {
          text: "Editar",
          active: true,
        },
      ],

      information: true,
      lista: [],
      type: [],
      typeEvent: [],
      lesion: [],
      agente: [],
      parteAfectada: [],
      subtype: [],
      listaII: [],
      file: null,
      item: null,
      loading1: true,
      itemData: null,

      medicion: {
        start_date: null,
        final_date: null,
        inability_type: null,
        extension: null,
        days_disability: null,
        file: null,
        diagnostic_code_id: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      showAutocomplete: false,
      showInput: true,
      descriptionCode: null,

      submitted: false,
      select: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],
      exist: false,
      cantidad: false,
      search: "",
      loading: true,
    };
  },

  validations: {
    medicion: {
      start_date: {
        required,
      },
      final_date: {
        required,
      },
      inability_type: {
        required,
      },
      file: {
        required,
      },
      diagnostic_code_id: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {

    handleOptionSelected(option) {
      this.medicion.diagnostic_code_id = option.id
    },

    hideInput() {
      this.showAutocomplete = true,
        this.showInput = false
    },

    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then(response => {
          this.exist = response.id
        })
        .catch(error => {
          console.log(error)
        })
    },

    getAccidents() {
      accidentAPI.getAllAccidents(this.companyID)
        .then((response) => {
          this.cantidad = response.Accident_report
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee;
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItemData() {
      ItemAPI.getItems(40)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 40)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
        * This method is used to send notification to SST user and SST company.
        * The sendNotification method import is required.
        * @param {Number} messageID - The message ID that will be associated to notification.
        * @param {Number} itemID - The item ID that will be associated to notification.
        * @param {Boolean} user - The user that will e associated to notification.
        * @return {Boolean} True if the notification is sent, false if not.
        */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
  */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getType() {
      accidentAPI.getType()
        .then((response) => {
          this.type = response.Accident_report_type;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSubType() {
      accidentAPI.getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          this.type = typeAccident
          this.subtype = typeAccident[0].report_subtype
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTypeEvent() {
      accidentAPI.getTypeEvent()
        .then((response) => {
          this.typeEvent = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gettypeOfInjury() {
      accidentAPI.gettypeOfInjury()
        .then((response) => {
          this.lesion = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAccidentAgent() {
      accidentAPI.getAccidentAgent()
        .then((response) => {
          this.agente = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInjuredPartBody() {
      accidentAPI.getInjuredPartBody()
        .then((response) => {
          this.parteAfectada = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      medicionAusentismoAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.medicion = {
            start_date: response.data.start_date,
            final_date: response.data.final_date,
            inability_type: response.data.inability_type,
            extension: response.data.extension,
            days_disability: response.data.days_disability,
            file: response.data.file,
            diagnostic_code_id: response.data.diagnostic_code_id,
            employee_id: response.data.employee_id,
            companies_id: response.data.companies_id,
          };
          this.descriptionCode = response.data.cod4 + ' ' + response.data.description4_codes
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionAusentismoAPI.getAll(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          this.loading1 = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.medicion.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.3.6/ausentismo/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/3.3.6/ausentismo/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.medicion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        medicionAusentismoAPI.update(this.$route.params.id, {
          start_date: this.medicion.start_date,
          final_date: this.medicion.final_date,
          inability_type: this.medicion.inability_type,
          extension: this.medicion.extension,
          days_disability: this.medicion.days_disability,
          file: this.medicion.file,
          diagnostic_code_id: this.medicion.diagnostic_code_id,
          employee_id: this.medicion.employee_id,
          companies_id: this.medicion.companies_id
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 40,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => { })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });

            this.sendNotification(54, 40, true)
            setTimeout(() => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Informacion actualizada con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              this.$router.go(-1);
            }, 3000)
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getAccidents()
    this.getUsers();
    this.getItems()
    this.getItem()
    this.getList();
    this.getItemData();
    this.getType();
    this.getSubType();
    this.getTypeEvent();
    this.gettypeOfInjury();
    this.getAccidentAgent();
    this.getInjuredPartBody();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">
          <div class="card">
            <div class="card-body">

              <form :disabled="!getRole('Crear') || !allowAccess()" class="form-group" @submit.prevent="save">
                <div>

                  <div>

                    <div class="form-row pt-3  px-3">
                      <b-form-group class="col-md-6" label="Colaborador" label-for="employee">
                        <select id="employeeID" class="form-control" v-model="medicion.employee_id">
                          <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                            {{ item.full_name }}
                          </b-form-select-option>
                        </select>

                      </b-form-group>

                      <b-form-group label="Tipo de incapacidad" required label-for="tipo" inline class="col-sm-6 pl-4">
                        <div>
                          <label class="mr-2 mt-1">
                            Accidente de trabajo
                          </label>
                          <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" style="color: #666"
                            value="Accidente_de_trabajo" v-model="medicion.inability_type"
                            class="mb-2 mr-sm-2 mb-sm-0  mt-1" label="accidente" />
                          <label class="mr-2 pl-sm-2 pl-md-0  mt-1">
                            Enfermedad general
                          </label>
                          <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" value="Enfermedad_general"
                            v-model="medicion.inability_type" class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                          <label class="mr-2 pl-sm-2 pl-md-0  mt-1">
                            Enfermedad laboral
                          </label>
                          <input :disabled="!getRole('Crear') || !allowAccess()" type="radio" value="Enfermedad_laboral"
                            v-model="medicion.inability_type" class="mb-2 mr-sm-2 mb-sm-0  mt-1" label="enfermedad" />
                        </div>
                      </b-form-group>

                    </div>

                    <div class="form-row pt-3 px-3">

                      <b-form-group class="col-md-6" label="Fecha inicio" label-for="trainingDate">
                        <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                          v-model="medicion.start_date">
                        </b-form-input>

                      </b-form-group>

                      <b-form-group class="col-md-6" label="Fecha fin" label-for="trainingDate">
                        <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="trainingDate"
                          v-model="medicion.final_date">
                        </b-form-input>

                      </b-form-group>

                    </div>

                    <div class="form-row pt-3  px-3">

                      <b-form-group class="col-md-3" label="Código diagnóstico" label-for="input-sm">
                        <div>
                          <!-- Utiliza el autocompletado cuando no hay texto o se activa el componente -->
                          <input v-if="showInput" type="text" class="form-control" v-model="descriptionCode"
                            @click="hideInput" @focus="showAutocomplete = true" />

                          <!-- Muestra el autocompletado cuando está activado -->
                          <Autocomplete v-if="showAutocomplete" @option-selected="handleOptionSelected"
                            v-model="medicion.diagnostic_code_id" required />
                        </div>
                      </b-form-group>

                      <b-form-group class="col-md-3" label="Días de incapacidad" label-for="input-sm">
                        <b-form-input type="number" maxlength="100" :disabled="!getRole('Crear') || !allowAccess()"
                          id="textarea" v-model="medicion.days_disability" rows="4"></b-form-input>
                      </b-form-group>

                      <b-form-group label="Prórroga" label-for="¿Evaluada el ultimo año?" inline
                        class="col-md-6 pl-5 pt-2">
                        <label class="mr-2">
                          Si
                        </label>
                        <input type="radio" style="color: #666" value="SI" v-model="medicion.extension"
                          class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0">
                          No
                        </label>
                        <input type="radio" value="NO" class="mb-2 mr-sm-2 mb-sm-0" label="incidente"
                          v-model="medicion.extension" />

                      </b-form-group>

                    </div>

                    <div class="form-row px-3">

                      <b-form-group class="col-md-12" label="Subir archivo" label-for="file">
                        <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                          name="file" browse-text="Buscar"
                          :placeholder="medicion.file ? getFile(medicion.file) : `Selecciona un archivo...`"
                          drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                          accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                        </b-form-file>

                      </b-form-group>
                    </div>
                  </div>

                  <div class="form-group text-right m-b-0">
                    <button :disabled="submitted" type="submit" class="btn btn-primary">
                      Guardar
                    </button>
                    <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                      Cancelar
                    </button>
                  </div>

                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>


      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>